import { Paths } from 'shared/routes/paths';
import { Task } from 'shared/types/task';
import { TaskActionType } from 'shared/types/task-action';
import { replaceUrlParams } from 'shared/utils/replace-url-params';

// An action-timeslot task opens the entity it blocks time for, not the task
// dialog. Every current action type maps to its detail route.
const timeslotDetailPaths: Partial<Record<TaskActionType, Paths>> = {
  [TaskActionType.GoalTimeslot]: Paths.GoalDetail,
  [TaskActionType.LifeAreaTimeslot]: Paths.LifeAreaDetail,
  [TaskActionType.TagTimeslot]: Paths.TagDetail,
  [TaskActionType.SmartListTimeslot]: Paths.SmartListDetail,
};

export const getTimeslotDetailUrl = (task: Task | undefined): string | null => {
  const actionType = task?.action?.type;
  const metaId = task?.action?.meta.id;
  const path = actionType ? timeslotDetailPaths[actionType] : undefined;
  if (!path || !metaId) {
    return null;
  }
  return replaceUrlParams(path, { id: metaId });
};
